import axios from 'axios';
import keycloak from '../services/keycloak';
import { ARGO_API_URL } from '../config';

const NO_RETRY_HEADER = 'x-no-retry';

const api = axios.create({
  baseURL: ARGO_API_URL
});

api.interceptors.request.use(
  async (config) => {
    if (keycloak.authenticated && keycloak.token) {
      try {
        await keycloak.updateToken(5);
      } catch {
        keycloak.login();
        return Promise.reject(new Error('Token refresh failed'));
      }
      config.headers.Authorization = `Bearer ${keycloak.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest.headers[NO_RETRY_HEADER]) {
      originalRequest.headers[NO_RETRY_HEADER] = 'true';
      try {
        await keycloak.updateToken(-1);
        originalRequest.headers.Authorization = `Bearer ${keycloak.token}`;
        return api(originalRequest);
      } catch {
        keycloak.login();
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
